import { Title as Component } from './styled';

export const Title = Component;
